import React from 'react';
import {submit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';

import {
  MODALS,
  fetchBooking,
  fetchKycs,
  fetchAgreements,
  fetchAffordabilities
} from 'ducks/bookings';

import {AddGuarantorForm} from './components';

class AddGuarantorModal extends React.Component<any> {
  getExtraActions = () => {
    const {data: {locationRef, bookingId}} = this.props;
    return [
      () => this.props.fetchBooking({locationRef, bookingId}),
      () => this.props.fetchKycs({bookingId}),
      () => this.props.fetchAffordabilities({bookingId}),
      () => this.props.fetchAgreements({bookingId}),
      ...this.props.closeModalExtraActions
    ];
  };

  triggerSubmit = () => {
    this.props.submit('addGuarantorForm');
  };

  render() {
    const {data: {form: {submitting}, bookingId}} = this.props;
    return (
      <Modal
        className="AddGuarantorModal"
        show={true}
        type={Modal.EXTRA_SMALL}
        onClose={this.props.closeModal}>
        <Modal.Header heading="Add Guarantor" />
        <Modal.Body>
          <AddGuarantorForm
            bookingId={bookingId}
            getExtraActions={this.getExtraActions}
          />
        </Modal.Body>
        <Modal.Footer>
          <Modal.SubmitButtons
            submitting={submitting}
            triggerSubmit={this.triggerSubmit}
            closeModal={this.props.closeModal}
            createLabel="Add Guarantor"
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToModalData = state => {
  return {
    form: {
      submitting: isSubmitting('addGuarantorForm')(state)
    }
  };
};

const mapDispatchtoProps = {
  fetchBooking,
  submit,
  fetchAffordabilities,
  fetchKycs,
  fetchAgreements
};

export default withModal(
  MODALS.ADD_GUARANTOR,
  mapStateToModalData,
  mapDispatchtoProps
)(AddGuarantorModal);
